module.exports = __webpack_public_path__ + "static/img/11.9c7c645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/11.png
// module id = ywge
// module chunks = 0